"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var ToolBarTextFilter = /** @class */ (function (_super) {
    __extends(ToolBarTextFilter, _super);
    function ToolBarTextFilter(props) {
        return _super.call(this, props) || this;
    }
    ToolBarTextFilter.prototype.onValueChange = function (e) {
        if (this.props.onFilterChanged) {
            this.props.onFilterChanged(e.target.value);
        }
    };
    ToolBarTextFilter.prototype.render = function () {
        return (React.createElement("div", { style: { display: "flex", width: this.props.width, flexWrap: "nowrap", justifyContent: "flex-start", alignItems: "center", marginBottom: "2px", marginLeft: "3px" } },
            React.createElement(antd_1.Input, { placeholder: this.props.captions.placeholder, value: this.props.filterVal, onChange: this.onValueChange.bind(this) })));
    };
    return ToolBarTextFilter;
}(React.Component));
exports.default = ToolBarTextFilter;



//////////////////
// WEBPACK FOOTER
// ./src/shared/components/toolbars/ToolBarTextFilter.tsx
// module id = 2500
// module chunks = 0